import { api } from "@/utils/api";
import { FormEvent, useState } from "react";
import { toast } from "@/utils/appToast";

type ResetPasswordFormProps = {
  email: string;
  onHide: () => void;
  token?: string;
};

export const ResetPasswordForm = ({ onHide, token }: ResetPasswordFormProps) => {
  const [isLoading, setIsLoading] = useState(false);

  const handleSubmit = async (e: FormEvent<HTMLFormElement>) => {
    e.preventDefault();
    setIsLoading(true);

    try {
      const formData = new FormData(e.currentTarget);
      const newPassword = formData.get("password") as string;
      const confirmPassword = formData.get("confirmPassword") as string;

      // ✅ Length check
      if (newPassword.length < 6) {
        toast.error("La contraseña debe tener al menos 6 caracteres");
        setIsLoading(false);
        return;
      }

      if (newPassword !== confirmPassword) {
        toast.error("Las contraseñas no coinciden");
        setIsLoading(false);
        return;
      }

      const data = await api.resetPassword({
        type: "email",
        newPass: newPassword,
        passRecoveryCode: token,
      });

      if (data.success) {
        toast.success("Contraseña restablecida con éxito");
        onHide();
      }
    } catch (error) {
      toast.error("Error al restablecer la contraseña");
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <form onSubmit={handleSubmit} className="default-form">
      <div className="form-group">
        <label className="text-white">Nueva contraseña</label>
        <input
          type="password"
          name="password"
          className="form-control"
          placeholder="Introducir nueva contraseña"
          required
          style={{
            borderRadius: 0,
            height: "50px",
            fontSize: "16px",
            padding: "10px 20px",
          }}
        />
      </div>

      <div className="form-group">
        <label className="text-white">Confirmar contraseña</label>
        <input
          type="password"
          name="confirmPassword"
          className="form-control"
          placeholder="Confirmar nueva contraseña"
          required
          style={{
            borderRadius: 0,
            height: "50px",
            fontSize: "16px",
            padding: "10px 20px",
          }}
        />
      </div>

      <div className="form-group">
        <button
          className="theme-btn btn-style-one w-100"
          type="submit"
          disabled={isLoading}
          style={{
            backgroundColor: "#1967d2",
            border: "none",
            height: "50px",
            fontSize: "16px",
            borderRadius: 14,
          }}
        >
          {isLoading ? (
            <div className="spinner-border spinner-border-sm" role="status"></div>
          ) : (
            "Restablecer contraseña"
          )}
        </button>
      </div>
    </form>
  );
};
